import { CurrencyCode } from "../../../Wrap/Constants/Enums/Domain/CurrencyCode";

export class CurrencySymbolDictionary {
    public static getSymbol(currencyCode: CurrencyCode) {
        if (CurrencySymbolDictionary.map == null) {
            CurrencySymbolDictionary.map = this.getMap();
        }

        if (CurrencySymbolDictionary.map.has(currencyCode)) {
            return CurrencySymbolDictionary.map.get(currencyCode);
        }
        throw new Error("Attempting to get currency symbol for unrecognized currency code");
    }
    private static map: Map<CurrencyCode, string>;

    private static getMap(): Map<CurrencyCode, string> {
        const map = new Map<CurrencyCode, string>();

        // TODO: add all supported currencies
        map.set(CurrencyCode.GBP, "£");
        map.set(CurrencyCode.CHF, "CHF");

        return map;
    }
}
